// extracted by mini-css-extract-plugin
export default {"root":"AXf2AeFRe8Lu5sCNNKVq","wrap":"qf7wDRhoRll9ZESNDq2Q","title":"YxCBinWRGiqJZIcl1wuf","copy":"rka47NtLTkJ1ItddmaHK","navigation":"tUJbuaRapLxMLTmPxcmQ"};